// extracted by mini-css-extract-plugin
export default {"tpWidget_home":"tpWidget_home--Y7GpC"};